import layout from '@/layout'

export default {
  path: '/config',
  component: layout,
  redirect: '/config/news',
  name: 'config_news',
  meta: {
    title: 'config',
    icon: 'config'
  },
  children: [
    {
      path: '/config/news',
      name: 'config_news',
      component: () => import('@/views/config/news/index'),
      meta: {
        title: 'config_news',
        icon: 'config'
      }
    }
  ]
}
